import { Divider, Grid, Heading, Text } from '@afterpaytouch/core'
import React, { FunctionComponent } from 'react'
import { useConsumerSizes } from '../../../utils/responsive'
import { Trans, useTranslation } from 'next-i18next'
import { useGetPreferredPayday, useIsPaydaySet } from '../../../state'

const I18N_NAMESPACE = ['common', 'account']

export const PreferredDayRemoval: FunctionComponent = () => {
  const { t } = useTranslation(I18N_NAMESPACE)
  const { subheadingSize } = useConsumerSizes()
  const preferredPayday = useGetPreferredPayday()
  const isPaydaySet = useIsPaydaySet()
  const weekDayMap: Record<string, number> = {
    Monday: 0,
    Tuesday: 1,
    Wednesday: 2,
    Thursday: 3,
    Friday: 4,
  }
  const weekdayCode = weekDayMap[preferredPayday ?? ''] ?? 0

  return (
    <>
      <div className='flex items-center'>
        <Heading bold size={subheadingSize} testNameSpace='body-title'>
          {t('account:tab:payment-methods:preferred-day:title')}
        </Heading>
      </div>
      <Grid>
        <Grid.Item sm={12} lg={6}>
          <div className='py-8' data-testid='preferred-day'>
            <div className='flex flex-row justify-between pb-2'>
              <div>
                {isPaydaySet ? (
                  <Text data-testid='preferred-day-active-text'>
                    <Trans
                      i18nKey='account:tab:payment-methods:preferred-day:description:removal:on'
                      values={{ selectedDay: t(`account:tab:payment-methods:preferred-day:weekday:${weekdayCode}`) }}
                      components={{
                        preferredDay: <Text renderAs='span' />,
                      }}
                    />
                  </Text>
                ) : (
                  <Text data-testid='preferred-day-inactive-text' size='M'>
                    {t(`account:tab:payment-methods:preferred-day:description:removal`)}
                  </Text>
                )}
              </div>
            </div>
            <Divider kind='Hairline' />
          </div>
        </Grid.Item>
      </Grid>
    </>
  )
}
